(function () {
  'use strict';

  /* ---- Gallery ---- */
  var mainImg  = document.getElementById('frm-prod-main-img');
  var thumbs   = document.querySelectorAll('.frm-prod__thumb');

  /* Build ordered image list from thumbnails (zoom-quality URLs preferred) */
  var galleryImages = [];
  thumbs.forEach(function (t) {
    galleryImages.push(t.dataset.zoom || t.dataset.full || t.src);
  });
  /* Fallback: if no thumbs, use main image */
  if (!galleryImages.length && mainImg) {
    galleryImages.push(mainImg.dataset.zoom || mainImg.src);
  }
  var galleryIndex = 0;

  thumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () {
      if (!mainImg) return;
      galleryIndex = i;
      mainImg.src = thumb.dataset.full;
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  /* ---- Tabs ---- */
  var tabBtns   = document.querySelectorAll('.frm-prod__tab-btn');
  var tabPanels = document.querySelectorAll('.frm-prod__tab-panel');

  tabBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      tabBtns.forEach(function (b) { b.classList.remove('active'); });
      tabPanels.forEach(function (p) { p.classList.remove('active'); });
      btn.classList.add('active');
      var panel = document.getElementById('frm-prod-tab-' + btn.dataset.tab);
      if (panel) panel.classList.add('active');
    });
  });

  /* ---- Quantity ---- */
  var qtyDisplay = document.getElementById('frm-prod-qty-display');
  var qtyInput   = document.getElementById('frm-prod-qty-input');
  var qty        = 1;

  function setQty(n) {
    qty = Math.max(1, n);
    if (qtyDisplay) qtyDisplay.textContent = qty;
    if (qtyInput)   qtyInput.value = qty;
  }

  var minusBtn = document.getElementById('frm-prod-qty-minus');
  var plusBtn  = document.getElementById('frm-prod-qty-plus');
  if (minusBtn) minusBtn.addEventListener('click', function () { setQty(qty - 1); });
  if (plusBtn)  plusBtn.addEventListener('click',  function () { setQty(qty + 1); });

  /* ---- Variants ---- */
  var variantsEl  = document.getElementById('frm-prod-variants-json');
  var variantInput = document.getElementById('frm-prod-variant-id');
  var priceEl      = document.getElementById('frm-prod-price');
  var addBtn       = document.getElementById('frm-prod-add-btn');

  /* ---- Variant dimension data (weight removed) ---- */
  var dimsDataEl = document.getElementById('frm-prod-dims-json');
  var dimsValEl  = document.getElementById('frm-prod-dims-val');
  var dimsData   = dimsDataEl ? JSON.parse(dimsDataEl.textContent) : null;

  function updateDims(variantId) {
    if (!dimsData || !dimsData[variantId]) return;
    var d = dimsData[variantId];
    if (dimsValEl) dimsValEl.textContent = d.dims || '—';
  }

  if (variantsEl) {
    var variants = JSON.parse(variantsEl.textContent);

    document.querySelectorAll('.frm-prod__size-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        document.querySelectorAll('.frm-prod__size-btn').forEach(function (b) {
          b.classList.remove('active');
        });
        btn.classList.add('active');

        var variantId = btn.dataset.variantId;
        var variant   = variants.find(function (v) { return String(v.id) === String(variantId); });

        if (variantInput && variantId) variantInput.value = variantId;

        if (variant && priceEl) {
          var was = variant.compare_at_price > variant.price
            ? '<s class="frm-prod__price-was">' + formatMoney(variant.compare_at_price) + '</s>'
            : '';
          priceEl.innerHTML = was + '<span class="frm-prod__price-now">' + formatMoney(variant.price) + '</span>';
        }

        /* Always keep the button enabled — availability enforced by policy=continue */
        if (addBtn) {
          addBtn.disabled    = false;
          addBtn.textContent = 'Add to Cart';
        }

        /* Clear any previous cart error */
        var errEl = document.getElementById('frm-prod-cart-error');
        if (errEl) { errEl.style.display = 'none'; errEl.textContent = ''; }

        updateDims(variantId);
      });
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ---- Wishlist: handled globally by assets/frm-wishlist.js, which
     auto-wires any [data-wish-toggle] button (including #frm-prod-wish-btn
     above) into the shared localStorage wishlist + header drawer. ---- */

  /* ---- AJAX Add to Cart — opens the theme's cart-drawer instead of
     redirecting to /cart. Mirrors the theme's own product-form pattern
     (assets/product.js): POST as FormData with a sections request so we
     get back freshly-rendered cart-drawer/main-cart/cart-bubble HTML,
     splice it in, then call the cart-drawer custom element's .open(). */
  var CART_DRAWER_SECTIONS = [
    { id: 'Cart',              section: 'main-cart',   selector: '.thb-cart-form' },
    { id: 'Cart',              section: 'main-cart',   selector: '.thb-cart-form--count' },
    { id: 'Cart-Drawer',       section: 'cart-drawer', selector: '.cart-drawer' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-count' },
    { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-secondary-area--item-amount' }
  ];

  function getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  function renderCartSections(sections) {
    CART_DRAWER_SECTIONS.forEach(function (s) {
      var container = document.getElementById(s.id);
      if (!container || !sections[s.section]) return;
      var target = container.querySelector(s.selector) || container;
      target.innerHTML = getSectionInnerHTML(sections[s.section], s.selector);
    });

    /* Only open the drawer if its content actually arrived — never force
       it open showing stale/empty markup from initial page load. */
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer && sections['cart-drawer'] && typeof drawer.open === 'function') {
      drawer.open();
      if (typeof drawer.removeProductEvent === 'function') drawer.removeProductEvent();
    }
  }

  var prodForm = document.getElementById('frm-prod-form');
  if (prodForm) {
    prodForm.addEventListener('submit', function (e) {
      e.preventDefault();

      var varId = document.getElementById('frm-prod-variant-id');
      var qtyEl = document.getElementById('frm-prod-qty-input');
      var errEl = document.getElementById('frm-prod-cart-error');
      var btn   = document.getElementById('frm-prod-add-btn');

      if (!varId || !varId.value) return;

      var prevText = btn ? btn.textContent : 'Add to Cart';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      if (errEl) { errEl.style.display = 'none'; errEl.textContent = ''; }

      var formData = new FormData();
      formData.append('id', parseInt(varId.value, 10));
      formData.append('quantity', parseInt((qtyEl && qtyEl.value) || 1, 10));
      /* Shopify's /cart/add expects `sections` as ONE comma-joined value,
         not repeated multipart fields — appending it multiple times (even
         with unique values) makes it silently keep only one of them.
         CART_DRAWER_SECTIONS maps several selectors to the same section
         name, so dedupe first, then send a single joined field. */
      var uniqueSections = CART_DRAWER_SECTIONS
        .map(function (s) { return s.section; })
        .filter(function (name, i, arr) { return arr.indexOf(name) === i; });
      formData.append('sections', uniqueSections.join(','));
      formData.append('sections_url', window.location.pathname);

      fetch((window.theme && window.theme.routes && window.theme.routes.cart_add_url) || '/cart/add.js', {
        method:  'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
        body: formData
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          /* Shopify returned an error — show inline, do NOT redirect */
          if (btn) { btn.disabled = false; btn.textContent = prevText; }
          if (errEl) {
            errEl.textContent  = data.description || data.message || 'Could not add to cart.';
            errEl.style.display = 'block';
          }
          return;
        }
        if (btn) { btn.disabled = false; btn.textContent = prevText; }
        if (data.sections) renderCartSections(data.sections);
      })
      .catch(function () {
        if (btn) { btn.disabled = false; btn.textContent = prevText; }
      });
    });
  }

  /* ---- Lightbox (click image to open, arrows to navigate) ---- */
  var LB_ID = 'frm-prod-lb';

  function lbClose() {
    var el = document.getElementById(LB_ID);
    if (el) { document.body.removeChild(el); document.body.style.overflow = ''; }
    document.removeEventListener('keydown', lbKeyHandler);
  }

  function lbNav(dir) {
    galleryIndex = (galleryIndex + dir + galleryImages.length) % galleryImages.length;
    var lbImg = document.getElementById(LB_ID + '-img');
    var lbCnt = document.getElementById(LB_ID + '-cnt');
    if (lbImg) {
      lbImg.style.opacity = '0';
      setTimeout(function () {
        lbImg.src = galleryImages[galleryIndex];
        lbImg.style.opacity = '1';
      }, 140);
    }
    if (lbCnt) lbCnt.textContent = (galleryIndex + 1) + ' / ' + galleryImages.length;
  }

  function lbKeyHandler(e) {
    if (e.key === 'Escape')      lbClose();
    if (e.key === 'ArrowLeft')   lbNav(-1);
    if (e.key === 'ArrowRight')  lbNav(1);
  }

  function lbOpen(index) {
    if (!galleryImages.length) return;
    galleryIndex = index;
    if (document.getElementById(LB_ID)) return;   /* already open */

    /* Overlay */
    var ov = document.createElement('div');
    ov.id = LB_ID;
    ov.style.cssText = 'position:fixed;inset:0;background:rgba(38, 38, 38, 0.92);z-index:9999;display:flex;align-items:center;justify-content:center;';
    ov.addEventListener('click', function (e) { if (e.target === ov) lbClose(); });

    /* Image */
    var img = document.createElement('img');
    img.id  = LB_ID + '-img';
    img.src = galleryImages[galleryIndex];
    img.style.cssText = 'max-width:90vw;max-height:88vh;object-fit:contain;border-radius:2px;transition:opacity 0.14s;display:block;';
    img.addEventListener('click', function (e) { e.stopPropagation(); });

    /* Close button */
    var xBtn = document.createElement('button');
    xBtn.innerHTML   = '&times;';
    xBtn.title       = 'Close';
    xBtn.style.cssText = 'position:absolute;top:14px;right:18px;background:rgba(245, 245, 245, 0.12);border:none;color:#F5F5F5;font-size:32px;line-height:1;width:44px;height:44px;border-radius:50%;cursor:pointer;z-index:2;display:flex;align-items:center;justify-content:center;';
    xBtn.addEventListener('click', lbClose);

    /* Counter */
    var cnt = document.createElement('div');
    cnt.id  = LB_ID + '-cnt';
    cnt.textContent = (galleryIndex + 1) + ' / ' + galleryImages.length;
    cnt.style.cssText = 'position:absolute;bottom:18px;left:50%;transform:translateX(-50%);color:rgba(245, 245, 245, 0.7);font-size:13px;letter-spacing:0.06em;z-index:2;pointer-events:none;';
    if (galleryImages.length <= 1) cnt.style.display = 'none';

    /* Arrows */
    var arrowStyle = 'position:absolute;top:50%;transform:translateY(-50%);background:rgba(245, 245, 245, 0.14);border:none;color:#F5F5F5;font-size:36px;width:52px;height:52px;border-radius:50%;cursor:pointer;z-index:2;display:flex;align-items:center;justify-content:center;transition:background 0.15s;';

    var prevBtn = document.createElement('button');
    prevBtn.innerHTML   = '&#8249;';
    prevBtn.title       = 'Previous image';
    prevBtn.style.cssText = arrowStyle + 'left:16px;';
    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); lbNav(-1); });
    prevBtn.addEventListener('mouseover', function () { this.style.background = 'rgba(245, 245, 245, 0.28)'; });
    prevBtn.addEventListener('mouseout',  function () { this.style.background = 'rgba(245, 245, 245, 0.14)'; });

    var nextBtn = document.createElement('button');
    nextBtn.innerHTML   = '&#8250;';
    nextBtn.title       = 'Next image';
    nextBtn.style.cssText = arrowStyle + 'right:16px;';
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); lbNav(1); });
    nextBtn.addEventListener('mouseover', function () { this.style.background = 'rgba(245, 245, 245, 0.28)'; });
    nextBtn.addEventListener('mouseout',  function () { this.style.background = 'rgba(245, 245, 245, 0.14)'; });

    if (galleryImages.length <= 1) { prevBtn.style.display = 'none'; nextBtn.style.display = 'none'; }

    ov.appendChild(xBtn);
    ov.appendChild(prevBtn);
    ov.appendChild(nextBtn);
    ov.appendChild(img);
    ov.appendChild(cnt);
    document.body.appendChild(ov);
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', lbKeyHandler);
  }

  /* Click on main image to open lightbox */
  if (mainImg) {
    mainImg.style.cursor = 'zoom-in';
    mainImg.addEventListener('click', function () { lbOpen(galleryIndex); });
  }
})();
